import useRolePermissions from '@/shared/composables/useRolePermissions';
import { ROLES, BUSINESS_ROLES } from '@/shared/assets/constants';
import { useStore } from 'vuex';

export default function useRole(store = useStore()) {
  const { settingsAccess } = useRolePermissions();

  return {
    isParent: store?.state?.role === ROLES.PARENT,
    isManager: store?.state?.role === ROLES.MANAGER,
    isSpecialist: store?.state?.role === ROLES.SPECIALIST,
    isAdmin: store?.state?.role === ROLES.SPECIALIST && settingsAccess,
    isBusinessAdmin: store?.state?.role === BUSINESS_ROLES.ADMIN,
    isBusinessMember: store?.state?.role === BUSINESS_ROLES.MEMBER,
  };
}
